/**
 * Produce display content without copying translated progress into the session.
 * IDs and hierarchy always come from the learner's original session.
 */
export const resolveCourseContent = (session: any, spanish: any): any => {
  if (!session || !spanish || session.id !== spanish.id || session.version !== spanish.version) {
    return session;
  }
  const translations = new Map<string, any>();
  const index = (node: any) => {
    translations.set(node.id, node);
    node.children?.forEach(index);
    node.possibleAnswers?.forEach(index);
  };
  index(spanish);

  const resolve = (node: any): any => {
    const translated = translations.get(node.id);
    const display = { ...node };
    if (translated && translated.type === node.type) {
      for (const field of ["title", "description"]) {
        if (typeof translated[field] === "string") display[field] = translated[field];
      }
      if (typeof translated.objectives === "string") {
        display.objectives = translated.objectives;
      } else if (translated.objectives && typeof translated.objectives === "object") {
        display.objectives = translated.objectives;
      }
      if (node.type === "video" && translated.url && translated.transcript) {
        display.url = translated.url;
        display.transcript = translated.transcript;
        display.contentLanguage = "es";
      }
      if (node.type === "resources" && Array.isArray(node.data)) {
        // Existing resource entries have no IDs; retain their order and metadata.
        display.data = node.data.map((resource, position) => {
          const localized = translated.data?.[position];
          return {
            ...resource,
            ...(typeof localized?.name === "string" ? { name: localized.name } : {}),
            ...(typeof localized?.link === "string" ? { link: localized.link } : {}),
          };
        });
      }
    }
    if (node.children) display.children = node.children.map(resolve);
    if (node.possibleAnswers) display.possibleAnswers = node.possibleAnswers.map(resolve);
    return display;
  };
  return resolve(session);
};

// Shared by the course page and helpers that look up module titles/related videos.
let previousSession: any;
let previousSpanish: any;
let previousDisplay: any;
export const selectDisplayedCourse = (state: any): any => {
  const session = state.course?.data;
  const spanish = state.application.currentLanguage === "es"
    ? state.course?.spanishContent
    : null;
  if (session !== previousSession || spanish !== previousSpanish) {
    previousSession = session;
    previousSpanish = spanish;
    previousDisplay = resolveCourseContent(session, spanish);
  }
  return previousDisplay;
};
